export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Perfil.vue?vue&type=template&id=f0a0a380&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Perfil.vue?vue&type=template&id=f0a0a380&scoped=true&
// module id = 585
// module chunks = 0